<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/modules/auth/stores/auth-store'
import { useWorkspaceStore } from '@/modules/workspace/stores/workspace-store'
import TheAppBanners from '@/modules/shared/components/the-app-banners.vue'
import TheSidenav from '@/modules/shared/components/the-sidenav.vue'
import { rails_url } from '@/modules/shared/utils/rails'

const route = useRoute()
const authStore = useAuthStore()
const workspaceStore = useWorkspaceStore()

const isSpvOrFundEntityPage = computed(() =>
  ['spv', 'fund', 'spvs', 'funds', 'gps'].includes(String(route.params.entity_type ?? '')),
)

const isSpvOrFundOverview = computed(() => isSpvOrFundEntityPage.value && route.name === 'investing.entity-overview')

const isBannerVisible = computed(
  () => workspaceStore.current.options.is_setup_mode_enabled && authStore.is_site_or_group_admin,
)
</script>

<template>
  <!-- Global banners: toasts, setup-mode banner, gradient bar (all users + viewports) -->
  <TheAppBanners />
  <!-- Impersonation banner (mobile) -->
  <div
    v-if="authStore.logged_in_as"
    class="fixed right-0 top-0 z-[51] sm:hidden"
    style="background-color: #ff853a; font-size: 11px; color: #fff; padding: 2px 4px"
  >
    <div style="float: right">
      <a
        style="padding: 2px 4px 1px 4px; background-color: rgba(255, 255, 255, 0.3)"
        :href="`${rails_url()}/login-as/${authStore.original_user.id}?new_dashboard=true`"
        >Stop</a
      >
    </div>
    <div style="float: right; margin-right: 10px">Viewing as {{ authStore.current_user.name }}</div>
  </div>
  <div
    class="fixed inset-0 flex overflow-hidden bg-white"
    :class="[!authStore.is_company_user ? 'top-[58px]' : 'top-0', isBannerVisible ? 'sm:top-8' : 'sm:top-0']"
  >
    <TheSidenav v-if="!authStore.is_company_user" />
    <main
      :class="[
        'h-full flex-grow overflow-y-auto',
        isSpvOrFundEntityPage ? 'bg-gray-50' : 'bg-white',
        { 'mt-8 sm:mt-0': isBannerVisible },
      ]"
    >
      <div
        :class="[
          'm-auto my-8 overflow-x-hidden px-0.5 py-6 sm:mx-12 sm:w-[inherit] sm:overflow-x-visible sm:px-0',
          { 'w-[95%]': !isSpvOrFundOverview },
        ]"
      >
        <slot></slot>
      </div>
    </main>
  </div>
</template>
